module.exports = __webpack_public_path__ + "fonts/GmarketSansTTFLight.efaa8f1.ttf";